<template>
  <b-form-group
    class="sid-range mb-2"
    :label="label"
  >
    <div class="flex items-center gap-4 justify-between">
      <vue-slider
        v-model="val"
        :interval="step"
        :max="getDimensionValue.max"
        :min="getDimensionValue.min"
        class="editor-slider-1 w-100"
        tooltip="none"
        @change="onChange"
      />

      <div class="mt-[-26px]">
        <div class="flex gap-[7px] text-[#A6A6A6] text-uppercase text-[11px] font-[600] mb-[11px]">
          <span
            v-for="dim in dimensions"
            :key="dim"
            class="cursor-pointer hover:text-[#44474A]"
            :class="{'text-[#44474A]': dimension === dim}"
            @click="() => dimension = dim"
            v-text="dim"
          />
        </div>

        <LinkedControlItem
          :value="val"
          :step="step"
          :ignore-zero="true"
          :max="getDimensionValue.max"
          :min="getDimensionValue.min"
          class="d-block !w-[57px] !text-[#7E7E7E] !text-[13px] !h-[29px]"
          :placeholder="sidValueMutation === 'auto' ? 'auto' : '-'"
          @input="onChange"
        />
      </div>
    </div>
    <div class="flex justify-end pt-2">
      <span 
        class="text-[13px] text-[#44474A] hover:opacity-80 cursor-pointer underline" 
        @click="onReset"
      >
        Reset
      </span>
    </div>
  </b-form-group>
</template>

<script>
import SidConcept from '@/components/mixins/SidConcept'
import LinkedControlItem from '@/components/editor/components/linked-control-group/LinkedControlItem.vue'

export default {
  name: 'SidFontSize',
  components: {LinkedControlItem},
  mixins: [SidConcept],
  props: {
    dimensions: {
      type: Array,
      default: () => ['px', 'rem']
    },
    defaultDimension: {
      type: String,
      default: 'px'
    },
    pxRange: {
      type: Array,
      default: () => [0, 320]
    },
    label: {
      type: String,
      default: 'Font Size'
    },
    ruleName: {
      type: String,
      default: 'font-size'
    },
    remRange: {
      type: Array,
      default: () => [0, 20]
    },
    selectedFontSize: {
      default: () => {
        return {
          fontSize: null
        }
      }
    }
  },
  data () {
    return {
      d: null
    }
  },
  computed: {
    val: {
      get () {
        // const val = this.d !== null ? parseFloat(this.d) : parseFloat(this.sidValueMutation) || ''
        // if (isNaN(this.d) || val > this.getDimensionValue.max) return ''
        // return val
        return this.selectedFontSize || this.d
      },
      set (val) {
        // this.d = val
        // this.addSidRules([[this.getSid(), [this.ruleName, isNaN(val) ? '' : `${val}${this.dimension || this.getDefaultDimension}`]]])
        //
        // if (!this.defaultValue && this.d === '') {
        //   setTimeout(() => this.val = parseFloat(this.getSidStyle()))
        // }
        this.apply(val)
      }
    },
    dimension: {
      get () {
        if (!this.measurement) {
          if (['normal', 'auto', 'contain'].includes(this.sidValueMutation)) return this.getDefaultDimension
          if (this.forceDimension) return this.forceDimension
          if (!this.dimensions.length) return ''
        }

        const regx = /(\d+(?:\.\d+)?)(px|%|rem|vh|vw)/.exec(this.sidValueMutation) || []
        return this.sidValueMutation !== '' && regx.length >= 3 ? regx[2] || this.getDefaultDimension : this.getDefaultDimension
      },
      set (val) {
        this.forceDimension = val

        if (this.measurement) {
          setTimeout(() => {
            if (val === 'px') {
              const value = parseInt(document.querySelector(this.getSid()).getBoundingClientRect()[this.measurement])
              this.d = value
              return this.addSidRules([[this.getSid(), [this.ruleName, `${value}${val}`]]])
            }
          }, 100)
        } else {
          this.addSidRules([[this.getSid(), [this.ruleName, `${parseInt(this.sidValueMutation)}${val}`]]])
        }
      }
    },
    getDimensionValue () {
      return this.dimension === 'px' ? {
        max: this.measurement || this.unlim ? 4000 : this.pxRange[1],
        min: this.pxRange[0]
      } : {
        max: this.max,
        min: this.min
      }
    },
    step () {
      if (this.dimension === 'px') {
        return 1
      } else {
        return 0.1
      }
    }
  },
  methods: {
    apply (val) {
      this.d = val
      this.addSidRules([[this.getSid(), [this.ruleName, isNaN(val) ? '' : `${val}${this.dimension || this.getDefaultDimension}`]]])

      if (!this.defaultValue && this.d === '') {
        setTimeout(() => this.val = parseFloat(this.getSidStyle()))
      }
    },
    onChange (val) {
      this.$emit('onFontSizeChange', {
        val: val.value,
        apply: () => this.apply(val.value)
      })
    },
    onReset () {
      this.d = null
      this.addSidRules([[this.getSid(), [this.ruleName, this.resetValue]]])
    }
  },
  watch: {
    sid () {
      this.d = null
    }
  }
}
</script>